/* global AppleID, FB, google */

Apt.fn.make('auth', {
	/**
	 * Bind auth events
	 */
	bind() {
		const scope = this;

		LS.util.idle([
			scope.bindLogin,
			scope.bindLogout,
			scope.bindRegister
		], scope);
	},

	/**
	 * Initialize login
	 */
	login() {
		const scope = this;

		LS.api.bind('$loginForm', 'auth/login', {
			namespace: 'auth',
			success: data => {
				scope.processLogin(data, 'email');
			}
		});

		scope.initServices();
	},

	/**
	 * Initialize registration
	 */
	register() {
		const scope = this;

		LS.api.bind('$registerForm', 'auth/register', {
			namespace: 'auth',
			success: data => {
				scope.processRegister(data, 'email');
			},
			validate: data => {
				const name = data.first_name + data.last_name;

				if (name && ! LS.validate.isMixedCase(name)) {
					LS.util.warn('Name must be "Title Case"');

					return false;
				}

				return true;
			}
		});

		scope.initServices();
	},

	/**
	 * Initialize forgot password
	 */
	forgot() {
		LS.api.bind('$forgotForm', 'auth/forgot', {
			namespace: 'auth',
			success: () => {
				LS.modal.close();
			}
		});
	},

	/**
	 * Prompt for login
	 *
	 * @param {Function} [fn]
	 * @param {Object} [options]
	 */
	prompt(fn, options) {
		if ($.routes.segments(1) === 'login') {
			return;
		}

		if (LS.user.active()) {
			$.exec(fn);

			return;
		}

		const scope = this;

		scope.fn = fn;

		LS.modal.open(Object.assign({
			url: '/auth/login/modal',
			success: () => {
				scope.login();
				scope.bindForgot(true);
				scope.bindRegister(true);
			},
			onHide: () => {
				$.events.reset('auth');
			}
		}, options));
	},

	/**
	 * Bind login
	 *
	 * @param {Boolean} [modal]
	 */
	bindLogin(modal) {
		const scope = this;

		$.events.on('$login', 'click', () => {
			scope.prompt();
		}, {
			cancel: true,
			delegate: modal ?
				'$modal' : '$header',
			namespace: modal ?
				'auth' : null
		});
	},

	/**
	 * Bind registration
	 *
	 * @param {Boolean} [modal]
	 */
	bindRegister(modal) {
		const scope = this;

		$.events.on('$register', 'click', () => {
			if ($.routes.segments(1) === 'register') {
				return;
			}

			LS.modal.open({
				url: '/auth/register/modal',
				success: () => {
					scope.register();
					scope.bindLogin(true);
				},
				onHide: () => {
					$.events.reset('auth');
				}
			});
		}, {
			cancel: true,
			delegate: modal ?
				'$modal' : '$header',
			namespace: modal ?
				'auth' : null
		});
	},

	/**
	 * Bind forgot password
	 *
	 * @param {Boolean} [modal]
	 */
	bindForgot(modal) {
		const scope = this;

		$.events.on('$forgot', 'click', () => {
			LS.modal.open({
				url: '/auth/forgot/modal',
				success: () => {
					scope.forgot();
					scope.bindLogin(true);
				},
				onHide: () => {
					$.events.reset('auth');
				}
			});
		}, {
			cancel: true,
			delegate: modal ?
				'$modal' : '$header',
			namespace: modal ?
				'auth' : null
		});
	},

	/**
	 * Bind logout
	 */
	bindLogout() {
		$.events.on('$logout', 'click', () => {
			LS.api.post('auth/logout', {
				auth: true,
				flash: false
			});

			LS.user.drop();

			LS.util.flash('Goodbye — you are logged out', 'success');

			const root = $.routes.segments(0);

			if (
				root === 'account' ||
				root === 'connect'
			) {
				location.href = '/';
			}
		}, {
			cancel: true,
			delegate: '$header'
		});
	},

	/**
	 * Process login
	 *
	 * @param {Object} data
	 * @param {String} method
	 */
	processLogin(data, method) {
		const scope = this;

		LS.user.set(data);

		LS.modal.close();

		$.exec(scope.fn);

		LS.analytics.event('login', {
			method: method,
			user_id: data.account.id
		});

		scope.processNav();
	},

	/**
	 * Navigate after login
	 */
	processNav() {
		const uri = $.routes.uri();
		const redirect = uri.query.return;

		if (redirect) {
			$.history.go(decodeURIComponent(redirect));
		} else if (uri.segments[0] === 'auth') {
			$.history.go('/account');
		}
	},

	/**
	 * Process registration
	 *
	 * @param {Object} data
	 * @param {String} method
	 */
	processRegister(data, method) {
		if (data.token) {
			LS.user.set(data);
		}

		LS.modal.close();

		$.exec(this.fn);

		const params = {
			method: method
		};

		if (data.account) {
			params.user_id = data.account.id;
		}

		LS.analytics.event('sign_up', params);

		if ($.routes.segments(0) === 'auth') {
			$.history.go('/account');
		}
	},

	/**
	 * Initialize auth services
	 */
	initServices() {
		const scope = this;

		$$('authService').on('click', (e, el) => {
			scope['init' + LS.util.capitalize(el.dataset.service)]();
		}, {
			namespace: 'auth'
		});
	},

	/**
	 * Initialize Apple
	 */
	initApple() {
		const scope = this;

		$.assets.load({
			js: 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
			success: () => {
				AppleID.auth.init({
					clientId: 'com.landsearch.auth-service',
					scope: 'name email',
					redirectURI: $.get('appUrl') + '/auth/apple',
					state: LS.util.uid(),
					usePopup: true
				});

				AppleID.auth.signIn()
					.then(response => {
						if (response && response.authorization) {
							scope.connectService('apple', {
								token: response.authorization.id_token,
								state: response.authorization.state,
								user: response.user
							});
						} else {
							scope.failService();
						}
					})
					.catch(e => {
						if (e.error === 'popup_closed_by_user') {
							return;
						}

						scope.failService();
					});

				$(window).on('message', event => {
					const data = event.data;

					if (data && data.type === 'APPLE_AUTH_SUCCESS') {
						scope.connectService('apple', {
							token: data.token,
							state: data.state
						});
					}
				}, {
					namespace: 'auth',
					once: true
				});
			}
		});
	},

	/**
	 * Initialize Facebook
	 */
	initFacebook() {
		const scope = this;

		$.assets.load({
			js: 'https://connect.facebook.net/en_US/sdk.js',
			success: () => {
				FB.init({
					appId: 217925998728540,
					version: 'v23.0'
				});

				FB.login(response => {
					if (response.authResponse) {
						scope.connectService('facebook', {
							token: response.authResponse.accessToken
						});
					} else {
						if (response.status === 'unknown') {
							return;
						}

						scope.failService();
					}
				}, {
					scope: 'email'
				});
			}
		});
	},

	/**
	 * Initialize Google
	 */
	initGoogle() {
		const scope = this;

		$.assets.load({
			js: 'https://accounts.google.com/gsi/client',
			success: () => {
				const client = google.accounts.oauth2.initTokenClient({
					client_id: '495794482008-t3qu7gbkjkjf5dnqdgbflmim6hm0fmtp.apps.googleusercontent.com',
					scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
					callback: response => {
						if (response && response.access_token) {
							scope.connectService('google', {
								token: response.access_token
							});
						} else {
							scope.failService();
						}
					}
				});

				client.requestAccessToken();
			}
		});
	},

	/**
	 * Connect service
	 *
	 * @param {String} service
	 * @param {Object} data
	 */
	connectService(service, data) {
		const scope = this;

		data.service = service;

		LS.api.post('auth/service', {
			data: data,
			success: data => {
				scope[data.new ? 'processRegister' : 'processLogin'](data, service);
			},
			error: () => {
				scope.failService();
			}
		});
	},

	/**
	 * Display service error
	 */
	failService() {
		LS.util.warn('Access failed using this method');
	}
});